// https://coolors.co/701f84-5951f2-5abac9-ed71a4-ffbd52-fed766-4dd177
// https://maketintsandshades.com/#701f84,ed71a4,5abac9,fed766,5cff7f,f7f9fc,5951f2,ffbd52

export const colors = {
  purple: "#701f84",
  pink: "#ed71a4",
  blue: "#5951f2",
  blue_green: "#5abac9",
  yellow: "#fed766",
  orange: "#ffbd52",
  green: "#3eab60",
  gray: "#f7f9fc",
  white: "#ffffff",
  text: "#1b1a35",
};

type ShadesType = {
  purple: [string, string, string, string, string, string, string, string, string, string];
  pink: [string, string, string, string, string, string, string, string, string, string];
  blue: [string, string, string, string, string, string, string, string, string, string];
  blue_green: [string, string, string, string, string, string, string, string, string, string];
  green: [string, string, string, string, string, string, string, string, string, string];
  yellow: [string, string, string, string, string, string, string, string, string, string];
  orange: [string, string, string, string, string, string, string, string, string, string];
  gray: [string, string, string, string, string, string, string, string, string, string];
  white: [string, string, string, string, string, string, string, string, string, string];
};
export const shades: ShadesType = {
  purple: [
    "#b88fc2",
    "#a979b5",
    "#9b62a9",
    "#8d4c9d",
    "#7e3590",
    "#701f84",
    "#651c77",
    "#5a196a",
    "#4e165c",
    "#43134f",
  ],
  pink: ["#f6b8d2", "#f4aac8", "#f29cbf", "#f18db6", "#ef7fad", "#ed71a4", "#d56694", "#be5a83", "#a64f73", "#8e4462"],
  blue: ["#aca8f9", "#9b97f7", "#8b85f6", "#7a74f5", "#6a62f3", "#5951f2", "#5049da", "#4741c2", "#3e39a9", "#353191"],
  blue_green: [
    "#addde4",
    "#9cd6df",
    "#8ccfd9",
    "#7bc8d4",
    "#6bc1ce",
    "#5abac9",
    "#51a7b5",
    "#4895a1",
    "#3f828d",
    "#367079",
  ],
  yellow: [
    "#ffebb3",
    "#fee7a3",
    "#fee394",
    "#fedf85 ",
    "#fedb75",
    "#fed766",
    "#e5c25c",
    "#cbac52",
    "#b29747",
    "#98813d",
  ],
  orange: [
    "#ffdea9",
    "#ffd186",
    "#ffd186",
    "#ffca75",
    "#ffc463",
    "#ffbd52",
    "#e6aa4a",
    "#cc9742",
    "#b38439",
    "#997131",
  ],
  green: ["#eafcef", "#daf3e2", "#b6e5c5", "#8fd6a5", "#6ec98a", "#58c278", "#4dbe6f", "#3ca75e", "#329452", "#228043"],
  gray: ["#f8f9fa", "#f1f3f5", "#e9ecef", "#dee2e6", "#ced4da", "#adb5bd", "#868e96", "#495057", "#343a40", "#212529"],
  white: ["#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff"],
};
